import axiosInstance from "./axiosConfig";

export const getNotifications = async () => {
  const response = await axiosInstance.get('/notifications');
  return response.data;
};

export const readAllNotification = async () =>{
  const response = await axiosInstance.patch('/notifications/mark_all_read');
  return response.data;
}

export const readNotification = async (id) => {
  const response = await axiosInstance.patch(
    `/notifications/${id}/mark_read`
  );
  return response.data;
};

export const notificationCsvDownload = async (id) =>{
  const response = await axiosInstance.get(`/notifications/${id}/download_csv`);
  return response.data;
}
export const notificationSetting = async () =>{
  const response = await axiosInstance.get(`/notifications/setting`);
  return response.data;
}

export const togglePushNotification = async (param) => {
  const response = await axiosInstance.patch(`/notifications/toggle_inapp`,param);
  return response.data;
};

export const toggleEmailNotification = async (param) =>{
  const response = await axiosInstance.patch(`/notifications/toggle_email`,param);
  return response.data;
}

